import React from "react";
import { createGlobalStyle } from "styled-components";
import { GlossyThemeProvider } from "@glossy";
import { background, content } from "@glossy/theme";

const GlobalStyle = createGlobalStyle`
  body {
    color: ${content};
    background-color: ${background};
    overflow: hidden;
  }

  #main {
    overflow-y: scroll;
  }

  button:focus {
    outline: none;
  }
`;

interface IProps {
  navbar: React.ReactNode;
  children: React.ReactNode;
  panel?: React.ReactNode;
}

const RadarlyPagesMain = ({ children, navbar, panel }: IProps) => (
  <>
    <GlobalStyle />
    <GlossyThemeProvider name="surface">{panel}</GlossyThemeProvider>
    {navbar}
    {children}
  </>
);

export default RadarlyPagesMain;
